export default "__VITE_ASSET__DtFRFqFj__"